/*
 *  I11PERCHARESCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 22:04:58 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

//TODO
import { fetchMasseVolumiqueViscosite, fetchPerteChargeUnite, fetchPerteChargeAccident } from '@batical/data/src'
import { RMasseVolumiqueViscosite_Type, RPerteChargeUniteCalculSchema_Type, I11PERCHARES_State } from '@batical/types/src'

import I11PERCHADISCHACalcul from './I11PERCHADISCHACalcul'
//TODO IF REQUIREDimport {} from '@batical/types/src';
function I11PERCHARES_docalcul(state: I11PERCHARES_State) {
  state.invalidated = false
  let cha_selectedviscosite: RMasseVolumiqueViscosite_Type = fetchMasseVolumiqueViscosite(state.contextCha.viscosite_uuid)
  let cha_selectedperteCharg: RPerteChargeUniteCalculSchema_Type = fetchPerteChargeUnite(state.contextCha.perteCharg_uuid)
  let selectedperteCharg: RPerteChargeUniteCalculSchema_Type = fetchPerteChargeUnite(state.pdcUnitSelected_uuid)
  state.res_totalDzeta = 0
  if (state.in_accidents > 0) {
    for (let i = 0; i < state.accidents.length; i++) {
      state.res_totalDzeta += fetchPerteChargeAccident(state.accidents[i].accident_uuid).dzeta * state.accidents[i].number
    }
  }

  state.contextCha = I11PERCHADISCHACalcul(state.contextCha)

  let pdcSinguliereLocalUnit = (state.contextCha.res_pdcTotale / cha_selectedperteCharg.factor) * selectedperteCharg.factor

  //res_pdcFrottement
  state.res_pdcFrottement =
    cha_selectedviscosite.masseVolumique *
    (Math.pow(state.contextCha.res_vitesse, 2) / 2) *
    state.res_totalDzeta *
    selectedperteCharg.factor
  //uniformisation des unités de calculs
  //quick and dirty
  state.res_pdfTotal = pdcSinguliereLocalUnit + state.res_pdcFrottement
  return state
}

export default I11PERCHARES_docalcul
